const examManage = () => import('./examManage');
const addOrEditExam = () => import('./addOrEditExam');

const Router = [
  {
    path: 'examManage',
    name: 'examManage',
    component: examManage,
    meta: {
      title: '考试管理',
    },
  },
  {
    path: 'addOrEditExam',
    name: 'addOrEditExam',
    component: addOrEditExam,
    meta: {
      title: '新增考试',
    },
  },
];
export default Router;
